<template>
  <hr
    role="separator"
    aria-orientation="horizontal"
  >
</template>
